import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableId = 'tableBonusWins';
var formId = 'formBonusWins';
var btnCancelSearchId = 'btnCancelSearch';
var FILTER_DELIM = '-delim-';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-12't>r>" + "<'row'<''i><''p>>";

var COLUMNS_INDEX = {
    TicketId: 0,
    Status: 1,
    Handpay: 2,
    Bonus: 3,
    Player: 4,
    Customer: 5,
    CustomerOperation: 6,
    PlayerWinAmount: 7,
    MainWinAmount: 8,
    Level: 9,
    Created: 10,
    Started: 11,
    Finished: 12,
    Canceled: 13,
    Result: 14
}

export interface WinsOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    urlCustomerDetail: string;
    urlPlayerDetail: string;
    urlBonusDetail: string;
    urlCustomerOperationDetail: string;
}

export class Wins extends PageBase<WinsOptions> {
    private _tableOptions: DatatableOptions;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _filterTicketId: JQuery;
    private _filterBonus: MultiSelectApi;
    private _filterCustomer: MultiSelectApi;
    private _filterCustomerOperation: MultiSelectApi;
    private _filterStatus: MultiSelectApi;
    private _filterHandpay: MultiSelectApi;
    private _filterPlayer: JQuery;
    private _filterLevel: MultiSelectApi;
    private _filterResult: MultiSelectApi;
    private _table: Datatable;
    private _filterStartedFrom: DateTimePickerApi;
    private _filterStartedTo: DateTimePickerApi;
    private _filterFinishedFrom: DateTimePickerApi;
    private _filterFinishedTo: DateTimePickerApi;
    private _filterCreatedFrom: DateTimePickerApi;
    private _filterCreatedTo: DateTimePickerApi;
    private _filterPaidCanceledFrom: DateTimePickerApi;
    private _filterPaidCanceledTo: DateTimePickerApi;

    constructor(options: WinsOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);
        var getCustomerDetailUrl = (rowData: any): string => (`${options.urlCustomerDetail}/${rowData.CustomerId}`);
        var getPlayerDetailUrl = (rowData: any): string => (`${options.urlPlayerDetail}/${rowData.PlayerId}`);
        var getBonusDetailUrl = (rowData: any): string => (`${options.urlBonusDetail}/${rowData.BonusId}`);
        var getCustomerOperationDetailUrl = (rowData: any): string => (`${options.urlCustomerOperationDetail}/${rowData.CustomerOperationId}`);

        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',

            scrollX: false,
            //autoWidth: true,
            fixedHeader: false,
            columns: [
                {
                    data: "Id",
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                { data: 'Status' },
                { data: 'Handpay' },
                {
                    data: 'BonusName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkBonusDetail${rowData.Id}' href='${getBonusDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'PlayerRemoteId',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkPlayerDetail${rowData.Id}' href='${getPlayerDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'CustomerName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkCustomerDetail${rowData.Id}' href='${getCustomerDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'CustomerOperationName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkCustomerDetail${rowData.Id}' href='${getCustomerOperationDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: 'PlayerWinAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='PlayerWinAmount${rowData.Id}'>${Utils.isNullOrUndefined(data) ? "" : data + " " + rowData.PlayerCurrency}</span>`)
                },
                {
                    data: 'MainWinAmount',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='MainWinAmount${rowData.Id}'>${Utils.isNullOrUndefined(data) ? "" : data + " " + rowData.MainCurrency}</span>`)
                },
                {
                    data: 'LevelCode',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='LevelCode${rowData.Id}'>${Utils.isNullOrUndefined(data) ? "" : data}</span>`)},
                {
                    data: 'Created',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Created${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)},
                {
                    data: 'Started',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Started${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)},
                {
                    data: 'Finished',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Finished${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'Canceled',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='PaidCanceled${rowData.Id}'>${Utils.isNullOrUndefined(data) ? DateUtils.toDefaultWithTime(rowData.Paid) : DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'Result',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='Result${rowData.Id}'>${Utils.isNullOrUndefined(data) ? "" : data}</span>`)},
                {
                    orderable: false,
                    data: 'filterButtons',
                    defaultContent: '',
                    searchable: false,
                    sortable: false
                }
            ],
            order: [[COLUMNS_INDEX.TicketId, "desc"]],
            callbacks: {
                //                createdRow: this.createdRow,
                preDrawCallback: this.preDrawCallback
            }//,
            //            rowDetail: {
            //                hasDetail: true,
            //                render: this.renderDetailRow
            //            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById(formId);
        this._btnCancelSearch = Utils.getJQueryById(btnCancelSearchId);
        this._filterTicketId = Utils.getJQueryById('filterGameRoundId');
        this._filterBonus = new MultiSelectApi('filterBonus');
        this._filterCustomer = new MultiSelectApi('filterCustomer');
        this._filterCustomerOperation = new MultiSelectApi('filterCustomerOperation');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._filterHandpay = new MultiSelectApi('filterHandpay');
        this._filterPlayer = Utils.getJQueryById('filterPlayer');
        this._filterLevel = new MultiSelectApi('filterLevel');
        this._filterResult = new MultiSelectApi('filterResult');
        this._filterStartedFrom = new DateTimePickerApi('filterStartedFrom');
        this._filterStartedTo = new DateTimePickerApi('filterStartedTo');
        this._filterFinishedFrom = new DateTimePickerApi('filterFinishedFrom');
        this._filterFinishedTo = new DateTimePickerApi('filterFinishedTo');
        this._filterCreatedFrom = new DateTimePickerApi('filterCreatedFrom');
        this._filterCreatedTo = new DateTimePickerApi('filterCreatedTo');
        this._filterPaidCanceledFrom = new DateTimePickerApi('filterPaidCanceledFrom');
        this._filterPaidCanceledTo = new DateTimePickerApi('filterPaidCanceledTo');

        this._table = new Datatable(tableId, this._tableOptions);

        // == attach to events
        // filter form submit -> redraw table
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterBonus.selectAll();
        this._filterCustomer.selectAll();
        this._filterCustomerOperation.selectAll();
        this._filterTicketId.val('');
        this._filterStatus.selectAll();
        this._filterHandpay.selectAll();
        this._filterPlayer.val('');
        this._filterLevel.selectAll();
        this._filterStartedFrom.clearDates();
        this._filterStartedTo.clearDates();
        this._filterFinishedFrom.clearDates();
        this._filterFinishedTo.clearDates();
        this._filterCreatedFrom.clearDates();
        this._filterCreatedTo.clearDates();
        this._filterPaidCanceledFrom.clearDates();
        this._filterPaidCanceledTo.clearDates();
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterTicketId = this._filterTicketId.val();
        datatable.columns(COLUMNS_INDEX.TicketId).search(filterTicketId);

        var filterBonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Bonus).search(filterBonus);

        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);

        var filterCustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.CustomerOperation).search(filterCustomerOperation);

        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Status).search(filterStatus);

        var filterHandpay = this._filterHandpay.isAllSelected() ? '' : this._filterHandpay.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Handpay).search(filterHandpay);

        var filterPlayer = this._filterPlayer.val();
        datatable.columns(COLUMNS_INDEX.Player).search(filterPlayer);

        var filterLevel = this._filterLevel.isAllSelected() ? '' : this._filterLevel.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Level).search(filterLevel);

        var filterResult = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Result).search(filterResult);

        var filterStartedFrom = this._filterStartedFrom.getUnixTimestamp();
        var filterStartedTo = this._filterStartedTo.getUTCDate();
        var filterStarted = filterStartedFrom + FILTER_DELIM + filterStartedTo;
        datatable.columns(COLUMNS_INDEX.Started).search(filterStarted);

        var filterFinishedFrom = this._filterFinishedFrom.getUnixTimestamp();
        var filterFinishedTo = this._filterFinishedTo.getUTCDate();
        var filterFinished = filterFinishedFrom + FILTER_DELIM + filterFinishedTo;
        datatable.columns(COLUMNS_INDEX.Finished).search(filterFinished);

        var filterCreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
        var filterCreatedTo = this._filterCreatedTo.getUTCDate();
        var filterCreated = filterCreatedFrom + FILTER_DELIM + filterCreatedTo;
        datatable.columns(COLUMNS_INDEX.Created).search(filterCreated);

        var filterPaidCanceledFrom = this._filterPaidCanceledFrom.getUnixTimestamp();
        var filterPaidCanceledTo = this._filterPaidCanceledTo.getUTCDate();
        var filterPaidCanceled = filterPaidCanceledFrom + FILTER_DELIM + filterPaidCanceledTo;
        datatable.columns(COLUMNS_INDEX.Canceled).search(filterPaidCanceled);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/Wins.ts
 **/